module.exports = __webpack_public_path__ + "6268b971bbe86a7603eca733862771ea.svg";